module.exports = __webpack_public_path__ + "static/img/1177_phase_function_Paper_Points.20cebb5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/1177_phase_function_Paper_Points.png
// module id = 3dnQ
// module chunks = 0